import React from "react";
import CategoryPage from "./CategoryPage";

function ChatraSanglap({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Chatra Sanglap"
      parentCategory="Media"
      parentCategoryValues={[
        "Photos & Videos",
        "PhotosVideos",
        "Media"
      ]}
      posts={posts}
      publications={publications}
    />
  );

}

export default ChatraSanglap;